import { createContext } from 'react'

const EAReportContext = createContext(null)

export default EAReportContext
